<template>
  <div ref="chartContainer" style="width: 100%; height: 100%">
    <div v-if="renderGraph" style="width: 100%; height: 100%">
      <slot></slot>
      <apexchart
        ref="apexChartRef"
        :height="height"
        :width="`${chartWidth}px`"
        :options="options"
        :series="series"
      ></apexchart>
      <!-- <apexchart
        ref="apexChartRef"
        :height="height"
        :width="`200px`"
        :options="options"
        :series="series"
      ></apexchart> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: String,
      options: Object,
      series: Array,
      resizeChecking: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      chartWidthDebounce: null,
      chartWidth: 300,
      renderGraph: false,
      checkRender: null,
    }),
    methods: {
      handleResize() {
        this.renderGraph = false;
        if (this.resizeChecking == true) {
          clearTimeout(this.chartWidthDebounce);
          this.chartWidthDebounce = setTimeout(() => {
            this.chartWidth = this.$refs.chartContainer.clientWidth;
            this.renderGraph = true;
          }, 100);
        } else {
          this.chartWidth = this.$refs.chartContainer.clientWidth;
          this.renderGraph = true;
        }
      },
      zoom(min, max) {
        this.$refs.apexChartRef.zoomX(min == 0 ? 1 : min, max);
      },
      dataPointSelection(index) {
        this.$refs.apexChartRef.toggleDataPointSelection(index, index);
      },
      updateSeries(newSeries, animate) {
        this.$refs.apexChartRef.updateSeries(newSeries, animate);
        // console.log(newSeries, animate);
      },
    },
    beforeDestroy: function () {
      window.removeEventListener("resize", this.handleResize);
      clearInterval(this.checkRender);
    },
    mounted() {
      setTimeout(() => {
        this.handleResize();
        if (this.resizeChecking == true) {
          window.addEventListener("resize", this.handleResize);
          this.checkRender = setInterval(() => {
            if (this.chartWidth != this.$refs.chartContainer.clientWidth) {
              this.handleResize();
            }
          }, 500);
        }
      }, 10);
    },
  };
</script>
